import { ajax } from '../../util'
export function submittingQuery(data: any) {
    return {
        type: 'SUBMITTING_QUERY',
        data
    }
}
export function submitQuerySuccess(data: any) {
    return {
        type: 'SUBMIT_QUERY_SUCCESS',
        data
    }
}
export function submitQueryError(data: any) {
    return {
        type: 'SUBMIT_QUERY_ERROR',
        data
    }
}

export function fetchQuery(data: object) {
    return(dispatch: any) => {
        dispatch(submittingQuery(true))
        const url = '/api/async_query/'

        ajax(url, data, 'POST').then(res => {
            if (res.hasError) {
                dispatch(submitQueryError(res))
            } else {
                dispatch(submitQuerySuccess(res))
            }
            // dispatch(fetchingSubscribes(false))
        })
    }
}

export function submittingQueryRealTime(data: any) {
    return {
        type: 'SUBMITTING_QUERY_REALTIME',
        data
    }
}
export function submitQueryRealTimeSuccess(data: any) {
    return {
        type: 'SUBMIT_QUERY_SUCCESS_REALTIME',
        data
    }
}
export function submitQueryRealTimeError(data: any) {
    return {
        type: 'SUBMIT_QUERY_ERROR_REALTIME',
        data
    }
}

export function fetchQueryRealTime(data: any) {
    return(dispatch: any) => {
        dispatch(submittingQueryRealTime(true))
        const url = '/api/status/'

        ajax(url, data, 'POST').then(res => {
            if (res.hasError) {
                dispatch(submitQueryRealTimeError(res))
            } else {
                dispatch(submitQueryRealTimeSuccess(res))
            }
            // dispatch(fetchingSubscribes(false))
        })
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/SearchInput/actions.tsx